
angular.module 'zc.core'

.factory 'BaseModalSelectorCtrl', () ->
  class BaseModalSelectorCtrl

    constructor: ($scope, $modalInstance, items) ->

      $scope.items = items
      $scope.selected = {
        item: $scope.items[0]
      }

      $scope.ok = () ->
        $modalInstance.close($scope.selected.item)

      $scope.cancel = () ->
        $modalInstance.dismiss('cancel')

.controller 'ModalSelectorCtrl', ($scope, $modalInstance, items, BaseModalSelectorCtrl) ->

  return new BaseModalSelectorCtrl($scope, $modalInstance, items)




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/modal_selector.controller.js.coffee